import { c as _c } from "react/compiler-runtime";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import IdentitySearch from "@/components/utils/input/identity/IdentitySearch";
import RepCategorySearch from "@/components/utils/input/rep-category/RepCategorySearch";
export default function CreateWaveVotingRep(t0) {
  const $ = _c(15);
  const {
    category,
    profileId,
    errors,
    setCategory,
    setProfileId
  } = t0;
  let t1;
  if ($[0] !== errors) {
    t1 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.VOTING_CATEGORY_CANNOT_BE_EMPTY);
    $[0] = errors;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isCategoryError = t1;
  let t2;
  if ($[2] !== errors) {
    t2 = errors.includes(CREATE_WAVE_VALIDATION_ERROR.VOTING_PROFILE_ID_CANNOT_BE_EMPTY);
    $[2] = errors;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isProfileIdError = t2;
  let t3;
  if ($[4] !== category || $[5] !== isCategoryError || $[6] !== setCategory) {
    t3 = <RepCategorySearch category={category} setCategory={setCategory} error={isCategoryError} />;
    $[4] = category;
    $[5] = isCategoryError;
    $[6] = setCategory;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isProfileIdError || $[9] !== profileId || $[10] !== setProfileId) {
    t4 = <IdentitySearch identity={profileId} setIdentity={setProfileId} error={isProfileIdError} />;
    $[8] = isProfileIdError;
    $[9] = profileId;
    $[10] = setProfileId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className="tw-grid md:tw-grid-cols-2 tw-gap-4">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}